/* istanbul ignore next */
export const noop = (_?: any) => {
};
